import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@rebass/grid';

const BCDImprint = () => {
    const {t} = useTranslation();

    return <Box>
        <p>
            BCD Chemie GmbH<br />
            Schellerdamm 16<br />
            21079 Hamburg<br />
            <br />
            <b>{t("PHONE")}:</b> +49 40 77173 0<br />
            <b>{t("EMAIL")}:</b> info@bcd-chemie.de<br />
            <br />
            <b>{t("MANAGIN_DIRECTORS")}:</b> Mike Dudjan, Christian Korr<br />
            <br />
            <b>{t("REGISTERED_DOMICILE")}:</b> Hamburg<br />
            <b>{t("DISTRICT_COURT")}:</b> Hamburg HRB 97718<br />
            <br />
            <b>{t("VAT_NUMBER")}:</b> DE 250 230 752
        </p>
    </Box>
}

export default BCDImprint
